import { useMemo } from 'react'
import type { Listing } from '~/models'
import { useIsEmbed } from '../browser'

export default function useMapListingLink(listing: Listing) {
  const isEmbed = useIsEmbed()

  return useMemo(() => {
    const link = `/listings/${listing.slug}`
    // if (isEmbed && client!.options.wordpressSiteUrl) {
    //   const base = client!.options.wordpressSiteUrl!.replace(/\/$/, '')
    //   return `${base}${link}`
    // }
    return link
  }, [isEmbed, listing])
}
